import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react'
import { Paper, Typography } from '@mui/material'
import {
  getStaticProps as getLayoutStaticProps,
  LayoutProps,
} from '../components/Layout'
import SanityImage from '../components/SanityImage'
import sanity from '../lib/sanity'

const Index = (props: Props) => {
  const { user, isLoading } = useAuth0()

  if (isLoading) return <div>Loading...</div>

  return (
    <Paper>
      <Typography variant="h6">Hello {user?.name}</Typography>
      <SanityImage src={props.example_image} width={400} height={600} />
    </Paper>
  )
}

interface Props extends LayoutProps {
  example_image: string
}

export const getStaticProps = async (): Promise<{ props: Props }> => ({
  props: {
    ...(await sanity.fetch(
      `*[_type == 'settings' && _id == 'settings'][0] {
        "example_image": example_image.asset._ref
      }`,
    )),
    ...(await getLayoutStaticProps()).props,
  },
})

export default withAuthenticationRequired(Index)
